import { throttle } from 'lodash';
import { useEffect, useMemo, useRef } from 'react';

const useThrottle = (callback: () => void, wait: number) => {
  const ref = useRef<any>(null);

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  const throttledCallback = useMemo(() => {
    const func = () => {
      ref.current?.();
    };

    return throttle(func, wait, { leading: false });
  }, []);

  return throttledCallback;
};

export default useThrottle;
